import { api } from "../api";

/**
 * findAllGroupsByCustomerIdAndSecretaryIdAndDepartmentIdCrudResponse - Function that finds on database all groups by department and status as crud response data
 * /groups/{customerId}/{departmentId}/{status}  
 * method GET  
 * @async-function
 */
const findAllGroupsByCustomerIdAndSecretaryIdAndDepartmentIdCrudResponse = async (token: string, customerId: number, userId: number, departmentId: number, status: string, page: number, size: number, ignoreDepartments: boolean = false) => {
    const response = await api.get(
        `/groups/${userId}/${customerId}/${departmentId}/${status}?page-${page}&size=${size}&ignoreDepartments=${ignoreDepartments}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default findAllGroupsByCustomerIdAndSecretaryIdAndDepartmentIdCrudResponse;